import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, BellOff, CheckCircle2, Loader2 } from "lucide-react";
import { enablePush, pushStatus } from "@/lib/push";

export const PushToggle = ({ compact }) => {
  const [state, setState] = useState("loading");
  useEffect(() => { pushStatus().then(setState).catch(() => setState("unsupported")); }, []);

  const onEnable = async () => {
    setState("working");
    try {
      await enablePush();
      setState("on");
      toast.success("Notifikasi Dana Masuk aktif di perangkat ini");
    } catch (e) {
      toast.error(e.message || "Gagal mengaktifkan notifikasi");
      setState(await pushStatus().catch(() => "off"));
    }
  };

  if (state === "loading" || (compact && state !== "off")) return null;
  if (state === "on") return (
    <div className="flex items-center gap-2 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-2xl p-3" data-testid="push-status-on">
      <CheckCircle2 className="h-4 w-4" /> Notifikasi HP aktif — Anda akan diberi tahu saat dana masuk.
    </div>
  );
  if (state === "denied" || state === "unsupported") return (
    <div className="flex items-start gap-2 text-xs text-slate-600 bg-slate-100 border border-slate-200 rounded-2xl p-3" data-testid="push-status-blocked">
      <BellOff className="h-4 w-4 shrink-0 mt-0.5" />
      {state === "denied" ? "Notifikasi diblokir. Izinkan notifikasi untuk situs ini di pengaturan browser/HP." : "Perangkat ini belum mendukung notifikasi. Di iPhone, pasang aplikasi ke Layar Utama terlebih dahulu."}
    </div>
  );
  return (
    <div className="flex items-center gap-3 bg-gradient-to-r from-blue-800 to-blue-600 text-white rounded-2xl p-3.5 shadow-lg shadow-blue-900/20" data-testid="push-enable-card">
      <BellRing className="h-8 w-8 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm">Aktifkan Notifikasi Dana Masuk</div>
        <div className="text-[11px] text-blue-100">Bunyi & pop-up di HP, walau aplikasi ditutup.</div>
      </div>
      <button onClick={onEnable} disabled={state === "working"} data-testid="push-enable-btn"
        className="bg-white text-blue-800 font-bold text-xs px-3.5 py-2 rounded-xl hover:bg-blue-50 active:scale-95 transition-transform disabled:opacity-70">
        {state === "working" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aktifkan"}
      </button>
    </div>
  );
};
